import { z } from 'zod';

import { UuidSchema } from '../common/id/id';
import { PermissionKeySchema } from '../access/permissions/permission-key/permission-key';
import { UserStatusSchema } from '../users/user-status';

/**
 * The authenticated actor as every controller sees it (`@CurrentUser()`).
 *
 * It is the access token's claims in domain language — the same data, named for
 * readers rather than for JWT byte count. `PermissionsGuard` builds its
 * `PermissionContext` straight from `granted`/`denied`/`isSuperAdmin`, so the
 * guard and the admin UI evaluate identical inputs through the identical
 * function (N22).
 */
export const SessionUserSchema = z.object({
  id: UuidSchema,
  status: UserStatusSchema,
  roles: z.array(z.string()),
  granted: z.array(PermissionKeySchema),
  denied: z.array(PermissionKeySchema),
  isSuperAdmin: z.boolean(),
  tokenVersion: z.number().int().min(0),
});

export type SessionUser = z.infer<typeof SessionUserSchema>;
